module.exports = __webpack_public_path__ + "static/img/scenarios3_pho.fb0c1b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scenarios3_pho.png
// module id = oqy+
// module chunks = 0